// JOBE-0158.3: Card — lightest-weight "discrete unit on the page" wrapper.
// Provides the stamp-shadow, ink outline, 2px radius, and paper background.
// No padding — consumers decide their own interior spacing.

import './Card.css';

/**
 * @param {object} props
 * @param {string|React.ElementType} [props.as='div'] — element type to render
 * @param {string} [props.className]
 * @param {React.ReactNode} props.children
 */
export function Card({ as: Tag = 'div', className = '', children, ...rest }) {
  return (
    <Tag className={['card', className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </Tag>
  );
}
